import { pushGaData } from '../../common';
import { normalizeId } from '../../utils';
import { DIGITARK_IDS } from '../store/FooterColumnStore';
export const TELIA_SOCIAL_MEDIA_COLUMN_IDS = ['281', '326', '37600'];
export const TELIA_PRIVACY_NOTICE_ITEM_IDS = ['15549', '17256', '44044'];
export const TELIA_COOKIE_SETTINGS_ITEM_IDS = ['38717', '38718', '44045'];
export const TELIA_FOOTER_BOTTOM_LINKS_COLUMN_IDS = ['272', '314', '37592'];
export const TELIA_FOOTER_BOTTOM_LINKS = [...TELIA_PRIVACY_NOTICE_ITEM_IDS, ...TELIA_COOKIE_SETTINGS_ITEM_IDS];
export const mapTeliaFooterColumns = (rootStore) => {
    const environmentStore = rootStore.environmentStore;
    const { setLocation } = rootStore.locationStore;
    const { columns } = rootStore.footerColumnStore;
    const pushItemClickData = (parentTitle, label) => {
        pushGaData({
            eventAction: `Footer Submenu Click - ${parentTitle}`,
            eventLabel: label,
        });
    };
    const mapColumnItems = (items, parentTitle) => {
        return items.filter((item) => !TELIA_FOOTER_BOTTOM_LINKS.includes(item.id)).map((item) => mapColumnItem(item, parentTitle));
    };
    const mapColumnItem = (item, parentTitle) => ({
        ...item,
        url: resolveUrl(item, environmentStore),
        onClick: (event) => {
            pushItemClickData(parentTitle, item.label);
            if (!item.url.startsWith('http') && environmentStore.app === 'public') {
                event.preventDefault();
                setLocation(event);
            }
        },
    });
    if (!columns) {
        return [];
    }
    return columns
        .filter((column) => !TELIA_SOCIAL_MEDIA_COLUMN_IDS.includes(column.id))
        .map((column, index) => ({
        ...column,
        id: normalizeId(`footer-${column.title}`),
        isTwoColumn: index === 0 || column.isTwoColumn,
        items: mapColumnItems(column.items || [], column.title),
    }));
};
export const mapTeliaFooterSocialMediaItems = (rootStore) => {
    const { columns } = rootStore.footerColumnStore;
    const socialMediaColumn = columns.find((column) => TELIA_SOCIAL_MEDIA_COLUMN_IDS.includes(column.id));
    return ((socialMediaColumn === null || socialMediaColumn === void 0 ? void 0 : socialMediaColumn.items) || []).map((item) => ({
        ...item,
        onClick: () => pushGaData({ eventAction: 'Footer Socialmedia Click', eventLabel: item.label }),
    }));
};
export const filterOutDigitarkItem = (socialMediaItems) => {
    return socialMediaItems.filter((item) => !DIGITARK_IDS.includes(item.id));
};
export const mapTeliaFooterBottomLinks = (rootStore) => {
    const { columns } = rootStore.footerColumnStore;
    const bottomLinksColumn = columns.find((column) => TELIA_FOOTER_BOTTOM_LINKS_COLUMN_IDS.includes(column.id));
    return ((bottomLinksColumn === null || bottomLinksColumn === void 0 ? void 0 : bottomLinksColumn.items) || [])
        .filter((item) => TELIA_FOOTER_BOTTOM_LINKS.includes(item.id))
        .map((item) => ({
        ...item,
        onClick: (event) => {
            pushGaData({ eventAction: 'Footer Bottom Link Click', eventLabel: item.label });
            if (item.url.startsWith('javascript:Cookiebot.show') && window.Cookiebot.show) {
                event === null || event === void 0 ? void 0 : event.preventDefault();
                window.Cookiebot.show();
            }
        },
        url: item.url.startsWith('javascript:') ? '#' : item.url,
    }));
};
export const getDigitarkLogoProps = (digitarkFooterItem = {}) => ({
    url: digitarkFooterItem.url,
    text: digitarkFooterItem.label,
    theme: 'dark',
});
export const getTeliaFooterFooter = (translate) => [
    {
        content: translate('footer.companyLabel'),
    },
    {
        content: translate('footer.companyTrademarkLabel'),
    },
];
export const socialMediaConf = {
    super: {
        facebookUrl: 'https://www.facebook.com/superhetked',
        instagramUrl: 'https://www.instagram.com/superhetked/',
        tikTokUrl: 'https://www.tiktok.com/@superhetked',
    },
    diil: {
        facebookUrl: 'https://www.facebook.com/MobiilioperaatorDiil/',
        instagramUrl: '',
        tikTokUrl: '',
    },
};
export const resolveUrl = (item, environmentStore) => {
    var _a, _b;
    if (((_a = item.url) === null || _a === void 0 ? void 0 : _a.startsWith('http')) || ((_b = item.url) === null || _b === void 0 ? void 0 : _b.startsWith('javascript:'))) {
        return item.url;
    }
    return environmentStore.app === 'public' ? item.url : environmentStore.URLData.getPublicLink(item.url);
};
//# sourceMappingURL=FooterColumnMapper.js.map